import React from 'react';

import SEOMeta from '@src/components/SEOMeta';

export default function InqueryPage() {
  return (
    <>
      <SEOMeta title="お問い合わせ" description="ICHI-INのお問い合わせです。" />
      <div className="mx-auto max-w-[800px] bg-white rounded-lg">
        <div className="py-4 my-6">
          <div className="my-6">
            <h1 className="my-8 text-3xl text-center">お問い合わせ</h1>
            <div className="overflow-y-auto relative w-full h-[1200px]">
              <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSckSpMaW0m2wBaNlGItaahg_-KdZyoF7YbMMd_A39oIxEjPlQ/viewform?embedded=true"
                width="700"
                height="520"
                frameBorder="0"
                marginHeight={0}
                marginWidth={0}
                className="absolute top-0 left-0 w-full h-full"
              >
                Loading…
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
